import { DomainDnsRecord } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { DnsRecordsTable } from '../DnsRecordsTable/index.js'

interface Props {
  domain: string
  dnsRecords: DomainDnsRecord[]
}

export const StatusReady = ({ domain, dnsRecords }: Props) => {
  return (
    <div className="flex flex-col space-y-3">
      <Text>
        <T
          defaultMessage="All set! You can now switch to {domain} by pressing the button below."
          id="Admin.Domain.TransferReady"
          values={{
            domain: <strong className="font-mono">{domain}</strong>,
          }}
        />
      </Text>
      <DnsRecordsTable dnsRecords={dnsRecords} />
    </div>
  )
}
